import Promise from 'bluebird';
import $ from 'jquery';
import ModalActions from 'actions/modal';
import AppStore from 'stores/anyguide/app';
import SessionTimeoutError from '../../views/plugins/global_error/SessionTimeoutError';

const _reqTimestamps = {};
let _reqUrl = null;
let _req = null;

function buildKey(url, params) {
  const query = $.param(params);
  return `${url}?${query}`;
}

function now() {
  return new Date().getTime() / 1000;
}

function requestStale(url, params) {
  const key = buildKey(url, params);
  return _reqTimestamps[key] === undefined || _reqTimestamps[key] < now() - 3;
}

function shouldFetch(url, params, method) {
  return method !== 'GET' || requestStale(url, params);
}

function shouldCache(url, params, method) {
  return method === 'GET';
}

function shouldAbortPrevious(url) {
  return _req && _reqUrl === url;
}

function abortRequest() {
  _req.abort();
  _req = null;
  _reqUrl = null;
}

const ApiService = {
  fetch({
    url,
    params = {},
    method = 'GET',
    force = false,
    json = false,
    abortPrevious = false,
  }) {
    return new Promise((resolve, reject) => {
      if (force || shouldFetch(url, params, method)) {
        // Abort any previously incomplete XHR requests to the same URL if specified
        if (abortPrevious && shouldAbortPrevious(url)) {
          abortRequest();
        }

        _reqUrl = url;
        _req = $.ajax({
          url,
          type: method,
          success: resolve,
          error: reject,
          ...(json
            ? {
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(params),
              }
            : { data: params }),
        })
          .done(() => {
            if (shouldCache(url, params, method)) {
              _reqTimestamps[buildKey(url, params)] = now();
            }
          })
          .fail((e) => {
            if (e.status === 401) {
              ModalActions.show({
                component: SessionTimeoutError,
                componentProps: {
                  timeoutMinutes: AppStore.get('login_expiry'),
                },
              });
            }
          });
      } else {
        resolve('CACHED');
      }
    });
  },
};

export default ApiService;
